import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  SpendTransactionsQuery,
  SpendTransactionsRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const spendTransactionsQuery = graphql(`
  query spendTransactions($request: SpendTransactionsRequest!) {
    spendTransactions(SpendTransactionsRequest: $request) {
      totalResults
      results {
        id
        transactionId
        amount
        date
        buyerGuid
        buyerName
        supplier
        supplierGuid
        supplierName
        fileId
        descriptiveFields {
          column
          data
          type
        }
      }
    }
  }
`);

/** A single invoiced-spend transaction row from the GraphQL query. */
export type SpendTransaction = SpendTransactionsQuery["spendTransactions"]["results"][number];

/**
 * A page of invoiced-spend transactions.
 * Powers the transactions table and the drill-down modal.
 */
export function useSpendTransactions(
  request: SpendTransactionsRequest,
  options?: UseQueryOptions<SpendTransactionsQuery, unknown, SpendTransactionsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["spendTransactions", request],
    spendTransactionsQuery,
    [{ request }],
    options,
  );

  return { data: data?.spendTransactions, ...rest };
}
